module.exports = __webpack_public_path__ + "img/person.bfd89ee9.svg";